export enum SIZE {
  BIG = "BIG",
  MEDIUM = "MEDIUM",
  SMALL = "SMALL",
  X_SMALL = "X_SMALL",
}
